import { date } from 'quasar'

export default ({ Vue,store }) => {
    const buttonDelay = (moduleDelay) => {
        if (store.getters['common/is_superuser']) return false
        else {
            let diff = date.getDateDiff(new Date(), store.getters[`common/${moduleDelay}`], 'minutes')
            if(diff >= 5) return false
            return true
        }

    }
    Vue.prototype.$buttonDelay = buttonDelay
}
